import React, { useEffect, useState } from 'react';
import { DataService } from '../services/DataService';
import { hideLeftPanel } from '../services/UIServices';
import { minutesDiff } from '../services/UtilityService';
import { useNavigate } from 'react-router-dom';


const FlightDetails = (props) => {
    const [flightInformation, setFlightInformation] = useState({});
    const [selectedSection, setSelectedSection] = useState('flightDetails');
    const history = useNavigate();

    useEffect(() => {

        setFlightInformation(props.flightInformation || {});
        console.log(flightInformation);
    }, [props]);

    const continueBooking = (e) => {
        e.preventDefault();
        // Implement the search functionality here
        // console.log({ tripType, from, to, departureDate, returnDate, travellers, travelClass, });
        history({ pathname: "/bookticket", search: '?id=' + flightInformation.id });
    };

    const labelStyle = {
        cursor: 'pointer',
        padding: '5px 20px',
        borderRadius: '3px',
        border: '1px solid #ddd',
        fontSize: '0.85rem',
    };

    const activeLabelStyle = {
        ...labelStyle,
        backgroundColor: '#f15d30',
        color: 'white',
        border: '1px solid #f15d30 !important',
    };


    return (
        <>
            <section className="ftco-section ftco-section2">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md heading-section text-center">
                            <h6 className="mb-2 mt-2">Flight Information</h6>
                        </div>
                        <button onClick={() => hideLeftPanel()} className='btn btn-primary float-right'>X</button>
                    </div>
                </div>
            </section>

            <section className="ftco-section ftco-section2">
                <div className="container container-scroll">
                    <div className="row mt-3">
                        <div className="col-md-12 text-center">
                            <label
                                style={selectedSection === 'flightDetails' ? activeLabelStyle : labelStyle}
                                onClick={() => setSelectedSection('flightDetails')}
                            >
                                <input
                                    type="radio"
                                    className="btn-check"
                                    name="section"
                                    value="flightDetails"
                                    autoComplete="off"
                                    style={{ display: 'none' }}
                                    checked={selectedSection === 'flightDetails'}
                                    onChange={() => setSelectedSection('flightDetails')}
                                />
                                Flight Details
                            </label>

                            <label
                                style={selectedSection === 'fareSummary' ? activeLabelStyle : labelStyle}
                                onClick={() => setSelectedSection('fareSummary')}
                            >
                                <input
                                    type="radio"
                                    className="btn-check"
                                    name="section"
                                    value="fareSummary"
                                    autoComplete="off"
                                    style={{ display: 'none' }}
                                    checked={selectedSection === 'fareSummary'}
                                    onChange={() => setSelectedSection('fareSummary')}
                                />
                                Fare Summary
                            </label>

                            <label
                                style={selectedSection === 'cancellation' ? activeLabelStyle : labelStyle}
                                onClick={() => setSelectedSection('cancellation')}
                            >
                                <input
                                    type="radio"
                                    className="btn-check"
                                    name="section"
                                    value="cancellation"
                                    autoComplete="off"
                                    style={{ display: 'none' }}
                                    checked={selectedSection === 'cancellation'}
                                    onChange={() => setSelectedSection('cancellation')}
                                />
                                Cancellation
                            </label>
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className="project-wrap">
                                <div className="text p-2">
                                    {selectedSection === 'flightDetails' && (
                                        <div>
                                            <div className='days'>
                                                <p>Flight: {flightInformation.OriginLocation} to {flightInformation.DestinationLocation}</p></div>
                                            <p>DEP: {new Date(flightInformation.DepartureTime).toLocaleString()} - ARI: {new Date(flightInformation.ArrivalTime).toLocaleString()}</p>
                                            {flightInformation.FlightSegment && flightInformation.FlightSegment.map((segment, segIndex, segments) => (
                                                <div key={segIndex}>
                                                    <p>
                                                        Layover at {segment.LayoverAirport} -
                                                        Arrival: {new Date(segment.ArrivalTime).toLocaleString()},
                                                        Departure: {new Date(segment.DepartureTime).toLocaleString()} -
                                                        Airline: {segment.Airlines}
                                                    </p>
                                                    <p>
                                                        Waiting Time: {minutesDiff(segment.DepartureTime, segment.ArrivalTime)[1]}
                                                    </p>
                                                </div>
                                            ))}


                                        </div>
                                    )}

                                    {selectedSection === 'fareSummary' && flightInformation?.FlightDetails?.PriceDetails && (
                                        <div>
                                            <div className='days'><p>Fare breakup</p></div>
                                            <p>Currency: {flightInformation.FlightDetails.PriceDetails.Currency}</p>
                                            <p>Base Fare: {flightInformation.FlightDetails.PriceDetails.BaseFare}</p>
                                            <p>Surcharges: {flightInformation.FlightDetails.PriceDetails.Surcharges}</p>
                                            <p>Instant Discount: {flightInformation.FlightDetails.PriceDetails.InstantDiscount}</p>
                                            <p>Total Fare: {flightInformation.FlightDetails.PriceDetails.TotalFare}</p>
                                        </div>
                                    )}


                                    {selectedSection === 'cancellation' && (

                                        <div>
                                            <div className='days'>
                                                <p>Flight: {flightInformation.OriginLocation} to {flightInformation.DestinationLocation}</p></div>

                                            <p>{flightInformation.FlightDetails?.CancellationDetails?.Refundable ? 'Refundable' : 'Non-refundable'} - Cancellation Fee: ${flightInformation.FlightDetails?.CancellationDetails?.CancellationFee}</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-md ">
                            <div className="form-group border-0">
                                <div className="form-field float-end">
                                    <input type="submit" onClick={continueBooking} value="Book Tickets" className="align-self-stretch btn btn-primary search_button" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default FlightDetails;
